module.exports = __webpack_public_path__ + "img/bg2.e47ad2e6.png";